import { DEFAULT_HOSTNAME } from "@/global/constants";
import { LoginWorkspace, Workspace } from "@/types/workspaces";

export const webApp =
  typeof WEB_APP !== "undefined"
    ? WEB_APP
    : process.env.WEB_APP || DEFAULT_HOSTNAME;

export const PERSONAL_WOKSPACE = "personal-mode";

/**
 * Returns true if the user has only one workspace account.
 *
 * @param workspaces - The workspaces the user has
 * @param hasIndividualAccount - Whether the user has an individual account
 * @returns True if the user has only one workspace account, false otherwise
 */
export function isSingleAccount(
  workspaces: Workspace[] | LoginWorkspace[],
  hasIndividualAccount: boolean,
) {
  return (
    workspaces.length === 0 ||
    (!hasIndividualAccount && workspaces.length === 1)
  );
}

/**
 * Returns the workspace host for a given host and slug.
 *
 * @param host - The host to get the workspace host for
 * @param slug - The slug to get the workspace host for
 * @returns The workspace host
 */
export function getWorkspaceHost(host: string, slug: string): string {
  const isProd =
    typeof IS_PROD !== "undefined"
      ? IS_PROD
      : process.env.NODE_ENV === "production";

  // Support testing production on Localhost
  if ((isProd && host.includes(".localhost")) || !isProd) {
    return host.replace("localhost", `${slug}.localhost`);
  }

  return host.replace("www.", `${slug}.`);
}

/**
 * Returns the workspace slug for a given host.
 *
 * @param host - The host to get the workspace slug for
 * @returns The workspace slug
 */
export function getWorkspaceSlug(host?: string): string | undefined {
  if (!host) return undefined;

  if (!webApp.endsWith(host)) {
    return host.split(".")[0];
  }

  return undefined;
}

/**
 * Returns true if the host is a workspace URL.
 *
 * @param host - The host to check
 * @returns True if the host is a workspace URL, false otherwise
 */
export function isWorkspaceUrl(host: string): boolean {
  return !webApp.endsWith(host) || host.includes(".localhost");
}
